import moment from 'moment';

export const disablePreviousDate = () => {
  var dtToday = new Date();

  var month: any = dtToday.getMonth() + 1;
  var day: any = dtToday.getDate();
  var year = dtToday.getFullYear();
  if (month < 10) month = '0' + month.toString();
  if (day < 10) day = '0' + day.toString();

  var maxDate = year + '-' + month + '-' + day;
  var allDates: any = document.querySelectorAll('input[type="datetime-local"]');
  for (var i: any = 0; i <= allDates?.length; i++) {
    allDates[i]?.setAttribute('min', maxDate);
  }
};

export function disabledDate(current) {
  // Can not select days before today and today
  return current && current < moment().endOf('day');
}

export function disabledDateTime() {
  return {
    disabledHours: () => range(0, 24).splice(4, 20),
    disabledMinutes: () => range(30, 60),
    disabledSeconds: () => [55, 56],
  };
}
function range(start, end) {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
}

export function getCurrentISODateTime() {
  var date = moment();
  var today = date.format().substring(0, 16);
  return today;
}

export function isDateFuture(date) {
  // Parse the ISO date using Moment.js
  const dateToCheck = moment(date);

  // Get the current date and time using Moment.js
  const currentDate = moment();

  // Compare the dates to see if exam is upcoming or not
  if (dateToCheck.isAfter(currentDate)) {
    return true;
  } else {
    return false;
  }
}

export function getFirstDayOfMonth(date) {
  return date && date.clone().startOf('month');
}
export function getLastDayOfMonth(date) {
  return date && date.clone().endOf('month');
}

export function getDatesOfMonth(date) {
  const currentDate = date;
  const firstDayOfMonth = getFirstDayOfMonth(currentDate);
  const lastDayOfMonth = getLastDayOfMonth(currentDate);

  const currentDay = currentDate?.clone();
  const datesTillToday = [];

  //for dates till today
  while (currentDay?.isSameOrAfter(firstDayOfMonth)) {
    datesTillToday.push(currentDay.format('YYYY-MM-DD'));
    currentDay.subtract(1, 'day');
  }

  //for all dates of given month
  const allDatesOfMonth = [];
  let day = firstDayOfMonth;

  while (day?.isSameOrBefore(lastDayOfMonth)) {
    allDatesOfMonth.push(day.format('YYYY-MM-DD'));
    day.add(1, 'day');
  }

  if (moment(date)?.isSame(new Date(), 'month')) {
    return datesTillToday;
  } else return allDatesOfMonth;
}
